(function () {
  var SELECTOR = "[data-impact-report-card-slider]";

  function queryAll(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initImpactReportCardSlider(section) {
    var scrollEl = section.querySelector("[data-impact-report-card-slider-scroll]");
    var trackEl = section.querySelector(
      "[data-impact-report-card-slider-progress-track]"
    );
    var thumbEl = section.querySelector(
      "[data-impact-report-card-slider-progress-thumb]"
    );
    var progressEl = section.querySelector(
      "[data-impact-report-card-slider-progress]"
    );
    if (!scrollEl || !trackEl || !thumbEl || !progressEl) return;

    var dragState = null;
    var trackDragState = null;

    function maxScroll() {
      return Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);
    }

    function clamp01(n) {
      return Math.max(0, Math.min(1, n));
    }

    function pointerProgress(ev) {
      var rect = trackEl.getBoundingClientRect();
      if (!rect.width) return 0;
      return clamp01((ev.clientX - rect.left) / rect.width);
    }

    function setScrollFromProgress(progress) {
      var max = maxScroll();
      if (max <= 1 || progressEl.hidden) return;
      scrollEl.scrollLeft = clamp01(progress) * max;
    }

    function updateScrollFit() {
      if (!section.classList.contains("impact-report-card-slider--inner-container")) {
        scrollEl.classList.remove("is-scroll-fitted");
        return;
      }
      var max = maxScroll();
      if (max <= 1) {
        scrollEl.classList.add("is-scroll-fitted");
      } else {
        scrollEl.classList.remove("is-scroll-fitted");
      }
    }

    function updateProgress() {
      var max = maxScroll();
      updateScrollFit();
      if (max <= 1) {
        progressEl.hidden = true;
        return;
      }
      progressEl.hidden = false;

      var trackW = trackEl.clientWidth;
      var ratio = scrollEl.clientWidth / scrollEl.scrollWidth;
      var thumbW = Math.max(ratio * trackW, 48);
      var p = max > 0 ? scrollEl.scrollLeft / max : 0;
      var travel = Math.max(0, trackW - thumbW);

      thumbEl.style.width = thumbW + "px";
      thumbEl.style.transform = "translateX(" + p * travel + "px)";
    }

    function isInteractiveTarget(el) {
      return !!(
        el &&
        el.closest &&
        el.closest("a[href], button, input, select, textarea")
      );
    }

    function onScroll() {
      updateProgress();
    }

    function onPointerDown(ev) {
      if (ev.pointerType !== "mouse" || ev.button !== 0) return;
      if (isInteractiveTarget(ev.target)) return;

      dragState = {
        pointerId: ev.pointerId,
        startX: ev.clientX,
        startScrollLeft: scrollEl.scrollLeft,
      };
      scrollEl.classList.add("is-dragging");
      try {
        scrollEl.setPointerCapture(ev.pointerId);
      } catch (_e) {}
    }

    function onPointerMove(ev) {
      if (!dragState || ev.pointerId !== dragState.pointerId) return;
      var dx = ev.clientX - dragState.startX;
      scrollEl.scrollLeft = dragState.startScrollLeft - dx;
    }

    function endDrag(ev) {
      if (!dragState) return;
      if (ev && ev.pointerId !== dragState.pointerId) return;
      dragState = null;
      scrollEl.classList.remove("is-dragging");
    }

    function onTrackPointerDown(ev) {
      if (ev.pointerType === "mouse" && ev.button !== 0) return;
      if (progressEl.hidden || maxScroll() <= 1) return;

      ev.preventDefault();
      trackDragState = { pointerId: ev.pointerId };
      setScrollFromProgress(pointerProgress(ev));
      try {
        trackEl.setPointerCapture(ev.pointerId);
      } catch (_e) {}
    }

    function onTrackPointerMove(ev) {
      if (!trackDragState || ev.pointerId !== trackDragState.pointerId) return;
      ev.preventDefault();
      setScrollFromProgress(pointerProgress(ev));
    }

    function endTrackDrag(ev) {
      if (!trackDragState) return;
      if (ev && ev.pointerId !== trackDragState.pointerId) return;
      trackDragState = null;
    }

    scrollEl.addEventListener("scroll", onScroll, { passive: true });
    scrollEl.addEventListener("pointerdown", onPointerDown);
    scrollEl.addEventListener("pointermove", onPointerMove);
    scrollEl.addEventListener("pointerup", endDrag);
    scrollEl.addEventListener("pointercancel", endDrag);
    trackEl.addEventListener("pointerdown", onTrackPointerDown);
    trackEl.addEventListener("pointermove", onTrackPointerMove);
    trackEl.addEventListener("pointerup", endTrackDrag);
    trackEl.addEventListener("pointercancel", endTrackDrag);
    window.addEventListener(
      "resize",
      function () {
        window.requestAnimationFrame(updateProgress);
      },
      { passive: true }
    );

    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(function () {
        updateProgress();
      });
      ro.observe(scrollEl);
      ro.observe(trackEl);
    }

    updateProgress();
  }

  function mountAll(root) {
    queryAll(root, SELECTOR).forEach(initImpactReportCardSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      mountAll(document);
    });
  } else {
    mountAll(document);
  }

  document.addEventListener("shopify:section:load", function (ev) {
    mountAll(ev.target);
  });
})();
